import { Component, OnInit, Output, EventEmitter, Input } from '@angular/core';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { LOGIN_PAGES } from '../enum-login-pages';
import { Router } from '@angular/router';
import { DynamicDialogRef } from 'primeng/dynamicdialog';
import {
  CognitoUserPool,
  CognitoUserAttribute,
  CognitoUser,
  AuthenticationDetails,
} from 'amazon-cognito-identity-js';
import { LoginService } from 'src/app/services/login-service/login.service';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { first, Observable } from 'rxjs';
import { ConfigService } from 'src/app/services/config-service/config.service';

enum ERROR_STATUS {
  INVALID_PASSWORD = 0,
  ATTEMPTS_EXCEED = 1,
}

@Component({
  selector: 'app-password',
  templateUrl: './password.component.html',
  styleUrls: ['./password.component.scss'],
})
export class PasswordComponent implements OnInit {
  @Output() nextStep = new EventEmitter<number>();
  @Input() email = '';
  @Input() userLocked = false;

  error = false;
  errorMessage = '';
  errorStatus = ERROR_STATUS;
  loading = false;

  frmLogin = new FormGroup({
    password: new FormControl('', Validators.required),
  });

  constructor(
    private router: Router,
    private dialogRef: DynamicDialogRef,
    private loginService: LoginService,
    private httpClient: HttpClient,
    private configService: ConfigService
  ) {}

  ngOnInit(): void {}

  back() {
    this.nextStep.emit(LOGIN_PAGES.EMAIL);
  }

  login() {
    if (this.userLocked) {
      this.error = true;
      this.errorMessage =
        'We’re having trouble accessing your account. Please contact your account manager.';
      return;
    }

    this.loading = true;
    const userPool = this.loginService.getCognitoUserPool();

    const cognitoUser = new CognitoUser({
      Username: this.email.toLowerCase(),
      Pool: userPool,
    });
    cognitoUser.authenticateUser(
      new AuthenticationDetails({
        Username: this.email.toLowerCase(),
        Password: this.frmLogin.value.password,
      }),
      {
        onSuccess: (res) => {
          this.onSuccessFun();
        },
        onFailure: (err) => {
          this.onFailureFun(err);
        },
      }
    );
  }

  forgotPassword() {
    this.nextStep.emit(LOGIN_PAGES.FORGOT_PASSWORD_EMAIL);
  }

  onSuccessFun() {
    this.loginService.getUser()?.subscribe({
      next: (response: any) => {
        this.loginService.setUser(response[0].json_build_object);
        this.router.navigate(['/launch']);
        this.dialogRef.close();
        this.loading = false;
      },
      error: (err) => {
        this.loading = false;
        console.error(err);
      },
    });
    this.error = false;
    this.errorMessage = '';
  }

  onFailureFun(err: any) {
    //NotAuthorizedException
    //this.error = ERROR_STATUS.INVALID_PASSWORD;
    this.error = true;
    if (err.code === 'NotAuthorizedException') {
      let params = new HttpParams();
      params = params.set('email', this.email.toLowerCase());

      const headers = new HttpHeaders({ 'Content-Type': 'application/json' });

      const submission$: Observable<any> = this.httpClient.post(
        this.configService.lockoutUserURL,
        null,
        { headers: headers, params: params }
      );
      submission$.pipe(first()).subscribe({
        next: (response: any) => {
          this.errorMessage = response.message;
          this.loading = false;
        },
        error: (err) => {
          console.error(err);
          this.loading = false;
        },
      });
    } else {
      this.loading = false;
      console.error(err.message);
    }
  }
}
